import React, { useEffect, useState } from "react"
import { useAppDispatch } from "../../../store"
import { setCurrentPage } from "../../../store/auth/authReducer"
import { Navigate, useLocation } from "react-router-dom"
import axios from "axios"
import Box from "@mui/material/Box"
import TextField from "@mui/material/TextField"
import Button from "@mui/material/Button"
import Snackbar from "@mui/material/Snackbar"
import Alert from "@mui/material/Alert"
import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"
import { useSelector } from "react-redux"
import { logOut } from "../../../utils/logOut"
import { useSnackbar } from "../../../utils/SnackbarContext"

export default function SynthVoice() {
    const dispatch = useAppDispatch()
    const location = useLocation()
    const [openSnackbar, setOpenSnackbar] = useState(false)
    const [snackbarType, setSnackbarType] = useState("")
    const [userData, setUserData] = useState<any>(null)

    const { showSnackbar } = useSnackbar();

    //Get params from URL
    const params = new URLSearchParams(location.search);
    const id = params.get('id');
    const type: string | null = params.get('type')

    //Get access level
    const accesslevel = useSelector(
        (state: any) => state.auth.authData.accesslevel
    )

    //Switch header title

    useEffect(() => {
        dispatch(setCurrentPage(type === "edit" ? `Edit voice` : 'Add voice'))
    }, [dispatch]);

    //Handle close snackbar
    const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };

    const getInitialVoiceData = () => ({
        voicecode: '',
        voicename: '',
        vendor: '',
        voiceorder: '10',
        ref_text: '',
        ref_audio: null,
    })

    //Get user
    async function fetchData(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/synthvoice/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })

            if (response.data !== null) {
                if (typeof (response.data) === 'object') {
                    const fetchedVoice = response.data[0]
                    setUserData(fetchedVoice)
                    setVoiceData({
                        ...getInitialVoiceData(),
                        ...fetchedVoice,
                        ref_audio: fetchedVoice?.ref_audio ?? null,
                    })
                }
                else showSnackbar('ERROR: INVALID SERVER RESPONSE', 'error')
            }

            console.log(response.data[0]);

        } catch (error: any) {
            console.log(error);
            if (error.code === "ERR_BAD_REQUEST") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    function convertFileToBase64(file: File) {
        return new Promise<string>((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (event: ProgressEvent<FileReader>) => {
                resolve(event.target?.result as string)
            };
            reader.onerror = (error) => {
                reject(error);
            };
            reader.readAsDataURL(file);
        });
    }

    const buildRequestPayload = (data: any = {}) => {
        return data
    }

    //Create contact group
    async function postData(data: any = {}) {
        const payload = buildRequestPayload(data)
        const isFormData = payload instanceof FormData

        try {
            const response = await axios.post(`https://cardgarantsales.com/restapi/synthvoice`, payload, {
                headers: {
                    ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })

            setSnackbarType('success')
            setOpenSnackbar(true)
        } catch (error: any) {
            setSnackbarType('error')
            setOpenSnackbar(true)
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Edit contact group
    async function putData(data: any = {}) {
        const payload = buildRequestPayload(data)
        const isFormData = payload instanceof FormData

        try {
            const response = await axios.put(`https://cardgarantsales.com/restapi/synthvoice/${id}`, payload, {
                headers: {
                    ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })

            setSnackbarType('success')
            setOpenSnackbar(true)
        } catch (error: any) {
            setSnackbarType('error')
            setOpenSnackbar(true)
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    const [voiceData, setVoiceData] = useState<any>(getInitialVoiceData())

    const handleAudioChange = async (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const input = event.target as HTMLInputElement
        const selectedFile = input.files?.[0]

        if (!selectedFile) {
            setVoiceData((prev: any) => ({ ...prev, ref_audio: null }))
            return
        }

        const isWavFile = selectedFile.type === 'audio/wav' || selectedFile.name.toLowerCase().endsWith('.wav')

        if (!isWavFile) {
            showSnackbar('Please select a WAV file', 'error')
            input.value = ''
            return
        }

        try {
            const base64Audio = await convertFileToBase64(selectedFile)
            setVoiceData((prev: any) => ({ ...prev, ref_audio: base64Audio }))
        } catch (error) {
            showSnackbar('Unable to read audio file', 'error')
            console.error(error)
            input.value = ''
        }
    }

    //On load if URL params contains type=edit
    useEffect(() => {
        type === 'edit' && fetchData()
        console.log(voiceData);

    }, [type])

    return (
        <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
            <Box>
                <Box sx={{ width: 220, display: "flex", mb: 2, flexWrap: "wrap", gap: 2 }}>
                    <TextField onChange={(e) => setVoiceData({ ...voiceData, voicecode: e.target.value !== '' ? e.target.value : null })} value={voiceData.voicecode || ''} variant="outlined" size="small" label='Voice Code*' />
                    <TextField onChange={(e) => setVoiceData({ ...voiceData, voicename: e.target.value !== '' ? e.target.value : null })} value={voiceData.voicename || ''} variant="outlined" size="small" label='Voice Name*' />
                    <TextField onChange={(e) => setVoiceData({ ...voiceData, vendor: e.target.value !== '' ? e.target.value : null })} value={voiceData.vendor || ''} variant="outlined" size="small" label='Vendor*' />
                    <TextField onChange={(e) => setVoiceData({ ...voiceData, voiceorder: e.target.value !== '' ? e.target.value : null })} value={voiceData.voiceorder || ''} variant="outlined" size="small" label='Voice Order*' />
                    <TextField onChange={(e) => setVoiceData({ ...voiceData, ref_text: e.target.value !== '' ? e.target.value : null })} value={voiceData.ref_text || ''} variant="outlined" size="small" label='Reference Text' />
                    <Button sx={{ width: '100%' }} variant="outlined" component="label">
                        {voiceData.ref_audio ? 'File uploaded' : 'Upload file (wav)'}
                        <input
                            type="file"
                            accept=".wav"
                            multiple={false}
                            hidden
                            onChange={handleAudioChange}
                        />
                    </Button>
                    {voiceData.ref_audio && (
                        <audio
                            controls
                            style={{ width: '100%', marginTop: 12 }}
                            src={typeof voiceData.ref_audio === 'string' ? voiceData.ref_audio : undefined}
                        />
                    )}
                </Box>
                <Button onClick={() => type === "edit" ? putData(voiceData) : postData(voiceData)} variant="contained" sx={{ width: "100%" }}>Save</Button>
            </Box>
            {type !== 'edit' && snackbarType === 'success' && <Navigate to='/synthvoices' />}
            <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleClose}>
                {snackbarType === 'error' ?
                    <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
                        Saving error
                    </Alert> :
                    <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
                        Successfully saved
                    </Alert>}
            </Snackbar>
        </Box >
    )
}